import faker from '@faker-js/faker';
import loopMap from 'mn-utils/loopMap';
import {TListItem} from './types';

export const getReferralMerchantsList = (limit: number): TListItem[] => {
  return loopMap(limit, () => {
    return getReferralMerchantDetails();
  });
};

export const getReferralMerchantDetails = (): TListItem => {
  const onboarding_statuses = ['completed', 'pending', 'failed', 'requested'];
  const min_kyc_statuses = ['onboarding', 'active', 'not_onboarded'];
  return {
    id: faker.datatype.uuid(),
    merchant_name: faker.name.findName(),
    merchant_email: faker.internet.email(),
    date_time: faker.date.recent().toISOString(),
    onboarding_statuses: (faker.helpers as any).arrayElement(onboarding_statuses),
    min_kyc_status: (faker.helpers as any).arrayElement(min_kyc_statuses),
  } as TListItem;
};